'use client'

import NiceModal from '@ebay/nice-modal-react'
import { useContext } from 'react'

/**
 * Whether more than one NiceModal is mounted in the store: `true` while another modal sits on top
 * of the caller's. Pass its negation to a base modal's `closeOnOutSideClick`, so a click on the
 * sub-modal's overlay does not also close the modal beneath it.
 *
 * Counts every entry, not just the visible ones. `BaseModal` removes its entry only once the exit
 * transition has finished, so a sub-modal that is still animating out counts as open and the base
 * modal's outside-click closing is not re-enabled too early. A NiceModal that bypasses `BaseModal`
 * must call `modal.remove()` on close, or its hidden entry keeps this `true`.
 */
export function useIsAnotherNiceModalOpened(): boolean {
    const modals = useContext(NiceModal.NiceModalContext)

    return Object.keys(modals).length > 1
}
